import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { Grid, Typography } from '@oresundsbron/bridge-ui';
import { formatDistanceToNow } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { InfoSkeleton } from './InfoSkeleton';
import { useLocale } from '~/stores/locale';
import { InfoItem } from './InfoItem';

export const WeatherInformation = () => {
  const { t } = useTranslation(['bridgeStatus', 'common'], {
    nsMode: 'fallback',
  });

  const { dateLocale } = useLocale();
  const { data: weather, isLoading } = useTypeSafeQuery(
    BackendQueryKeys.Weather(),
    (req) => req.BridgeStatus.weather(),
    {
      retry: 2,
      refetchInterval: 15 * 60 * 1000, // poll interval 15 mins
      refetchIntervalInBackground: true,
    }
  );
  return (
    <div className="col-start-2 mt-10">
      {isLoading ? (
        <InfoSkeleton />
      ) : (
        <Grid>
          <div className="col-span-full">
            <Typography as="h3" intent="title" size="lg">
              {t('bridgeStatus.weather.heading')}
            </Typography>
            <div className="text-sm text-neutral-700 first-letter:uppercase">
              {weather?.updated &&
                `${t('bridgeStatus.weather.lastUpdated')} ${formatDistanceToNow(
                  new Date(weather.updated.replace(' ', 'T')),
                  { addSuffix: true, locale: dateLocale }
                )}`}
            </div>
          </div>

          <InfoItem
            titleKey={'bridgeStatus.weather.labels.temperature'}
            value={
              weather?.temperature !== null &&
              weather?.temperature !== undefined
                ? `${weather?.temperature} ${t(
                    'bridgeStatus.weather.temperatureUnit'
                  )}`
                : '-'
            }
          />
          <InfoItem
            titleKey={'bridgeStatus.weather.labels.windDirection'}
            value={
              weather?.direction !== null && weather?.direction !== undefined
                ? `${weather?.direction}`
                : '-'
            }
          />
          <InfoItem
            titleKey={'bridgeStatus.weather.labels.windspeed'}
            value={
              weather?.windspeed !== null && weather?.windspeed !== undefined
                ? `${weather?.windspeed} ${t(
                    'bridgeStatus.weather.windSpeedUnit'
                  )}`
                : '-'
            }
          />
        </Grid>
      )}
    </div>
  );
};
